import BoardContentContext from '@/context/apps/board/BoardContentContext';
import dayjs from 'dayjs';
import { useTranslation } from 'next-i18next/pages';
import { useContext } from 'react';

import Profile from '@/components/shared/ui/profile/Profile';

import Overview from '../../ui/overview/Overview';

export default function BoardDetailTop() {
  const { t } = useTranslation('common');
  const context = useContext(BoardContentContext);
  if (!context) {
    throw new Error('Cannot find BoardContentContext');
  }

  const { data } = context;
  const { bc } = data;

  return (
    <div className="pb-6 border-b border-solid border-apps-coreProductDivider">
      <div className="relative h-full w-full text-apps-corePrimary01">
        {/* TODO : 카테고리 API 추가 후, 실 데이터로 교체 */}
        <h2 className="mb-[15px] text-[32px] font-bold leading-[150%] text-apps-coreGrayBlack [word-wrap:wrap] [overflow-wrap:break-word]">{bc?.title}</h2>
        <div className="flex items-center gap-2">
          {/* TODO - 회원 이미지 연동하기 */}
          <Profile src={undefined} size="md" alt={t('프로필이미지')} />
          <div className="flex w-full items-center justify-between">
            <div className="flex flex-col gap-0.5 lg:flex-row lg:items-center lg:gap-4">
              {bc && (
                <div className="flex items-center gap-1">
                  <p className="text-sm font-normal leading-[150%] text-apps-coreGrayBlack">{bc.writer}</p>
                </div>
              )}
              {bc && (
                <div className="flex items-center gap-2">
                  <Overview color="gray" icon="talkbox">
                    {bc?.comment_count?.toLocaleString() ?? 0}
                  </Overview>
                  <Overview color="gray" icon="eye">
                    {bc?.count?.toLocaleString() ?? 0}
                  </Overview>
                  <p className="text-xs font-normal leading-[150%] text-apps-brandGray100">
                    {dayjs(bc.uploaded_at).format('YYYY-MM-DD')}
                  </p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
